const {RRule} = require('rrule')
const addDays = require('date-fns/add_days')

const getRuleWeekDay = (day) => {
  switch (day) {
    case '0':
      return RRule.SU

    case '1':
      return RRule.MO

    case '2':
      return RRule.TU

    case '3':
      return RRule.WE

    case '4':
      return RRule.TH

    case '5':
      return RRule.FR

    case '6':
      return RRule.SA

    default:
      return RRule.SU
  }
}

const getUntilDate = (deliveryFrequencyWeeks, refDate) => {
  // The goal is to show at least 2 delivery dates for each route
  // so we add an extra week to make sure of that
  const WEEKLYUPDATE = 15
  const days = WEEKLYUPDATE + ((deliveryFrequencyWeeks - 1) * 7)
  return addDays(refDate, days)
}

const INTEGER_TO_DISPLAY_DAY = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
}

const DISPLAY_DAY_TO_INTEGER = {
  'Sunday': 0,
  'Monday': 1,
  'Tuesday': 2,
  'Wednesday': 3,
  'Thursday': 4,
  'Friday': 5,
  'Saturday': 6
}

// SL route docs have 'day' prop that's a number 0 - 6
// The ops sheet expects a visit_day shown as day of week.
// (the lib rrule does not return a display day)
function getVisitDisplayDay (inputDay) {
  const displayDay = INTEGER_TO_DISPLAY_DAY[inputDay]

  // this is validated on route doc save but just in case
  return (inputDay === undefined || inputDay === null || !displayDay)
    ? null
    : displayDay
}

const RouteStatus = {
  PROVISIONAL: 'provisional',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  ACCEPTED: 'accepted',
  IN_TRANSIT: 'in_transit',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
}

const VEHICLE_CLASS = [
  {
    name: 'TRCK_2CUMT',
    displayName: 'Truck 2 CUMT',
    maxVolume: 2
  },
  {
    name: 'TRCK_4CUMT',
    displayName: 'Truck 4 CUMT',
    maxVolume: 4
  },
  {
    name: 'TRCK_7CUMT',
    displayName: 'Truck 7 CUMT',
    maxVolume: 7
  },
  {
    name: 'TRCK_10CUMT',
    displayName: 'Truck 10 CUMT',
    maxVolume: 10
  },
  {
    name: 'TRCK_14CUMT',
    displayName: 'Truck 14 CUMT',
    maxVolume: 14
  },
  {
    name: 'TRCK_15CUMT',
    displayName: 'Truck 15 CUMT',
    maxVolume: 15
  },
  {
    name: 'TRCK_20CUMT',
    displayName: 'Truck 20 CUMT',
    maxVolume: 20
  },
  {
    name: 'TRCK_21CUMT',
    displayName: 'Truck 21 CUMT',
    maxVolume: 21
  },
  {
    name: 'TRCK_40CUMT',
    displayName: 'Truck 40 CUMT',
    maxVolume: 40
  }
]

module.exports = {
  getUntilDate,
  getRuleWeekDay,
  getVisitDisplayDay,
  INTEGER_TO_DISPLAY_DAY,
  DISPLAY_DAY_TO_INTEGER,
  VEHICLE_CLASS,
  RouteStatus
}
